// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","713":"component---src-templates-using-dsg-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"4fffce1ecfea467ce4da","678":"3261c4abc6de5b849b36","713":"a2e7c7e97f10f796fd17","883":"59ee7c27dcaba5b22ac5"}[chunkId] + ".js";
};